import { z } from 'zod'
import type { TwoFactorBackupCodesRemaining } from '../../models/TwoFactorBackupCodesRemaining'

export const TwoFactorBackupCodesRemainingDTO = z.object({
  remaining: z.number().int().min(0)
})

export type TwoFactorBackupCodesRemainingDTO = z.infer<typeof TwoFactorBackupCodesRemainingDTO>

export function mapDTOToTwoFactorBackupCodesRemaining (
  dto: TwoFactorBackupCodesRemainingDTO
): TwoFactorBackupCodesRemaining {
  return {
    remaining: dto.remaining
  }
}

export function mapTwoFactorBackupCodesRemainingToDTO (
  model: TwoFactorBackupCodesRemaining
): TwoFactorBackupCodesRemainingDTO {
  return {
    remaining: model.remaining
  }
}
